import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconInfoLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 16.75a.722.722 0 0 0 .534-.216.726.726 0 0 0 .216-.534v-4.25a.726.726 0 0 0-.216-.534A.726.726 0 0 0 12 11a.725.725 0 0 0-.534.216.726.726 0 0 0-.216.534V16c0 .212.072.39.216.534a.726.726 0 0 0 .534.216Zm0-7.461a.78.78 0 0 0 .575-.233.782.782 0 0 0 .233-.575.782.782 0 0 0-.232-.576.782.782 0 0 0-.576-.232.782.782 0 0 0-.575.232.782.782 0 0 0-.233.576c0 .229.078.42.232.575A.782.782 0 0 0 12 9.29Zm.002 12.211a9.254 9.254 0 0 1-3.706-.748 9.596 9.596 0 0 1-3.016-2.03 9.595 9.595 0 0 1-2.032-3.016 9.246 9.246 0 0 1-.748-3.704c0-1.314.25-2.55.748-3.706a9.596 9.596 0 0 1 2.03-3.016 9.594 9.594 0 0 1 3.016-2.032 9.246 9.246 0 0 1 3.704-.748c1.314 0 2.55.25 3.706.748a9.596 9.596 0 0 1 3.017 2.03 9.594 9.594 0 0 1 2.03 3.016 9.247 9.247 0 0 1 .749 3.704 9.27 9.27 0 0 1-.748 3.706 9.596 9.596 0 0 1-2.03 3.017 9.595 9.595 0 0 1-3.016 2.03 9.247 9.247 0 0 1-3.704.749ZM12 20c2.233 0 4.125-.775 5.675-2.325C19.225 16.125 20 14.233 20 12c0-2.233-.775-4.125-2.325-5.675C16.125 4.775 14.233 4 12 4c-2.233 0-4.125.775-5.675 2.325C4.775 7.875 4 9.767 4 12c0 2.233.775 4.125 2.325 5.675C7.875 19.225 9.767 20 12 20Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconInfoLine;
